import GeneratedOutOfOfficeServiceApi from "./generated/GeneratedOutOfOfficeServiceApi"

class OutOfOfficeServiceApi extends GeneratedOutOfOfficeServiceApi {

}

export const outOfOfficeServiceApi = new OutOfOfficeServiceApi()
